import { atom } from 'recoil';
import { WsType } from '../types/webService';

export const wsTypeState = atom<WsType | undefined>({
  key: 'app.logs.wsType',
  default: undefined,
});
